import React from 'react';

const Background = () => {
    return (
        <div className="ambient-background">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
        </div>
    );
};

export default Background;
